import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../../services/auth.service';
import { NbLoginComponent, NbAuthSocialLink, getDeepFromObject, NbAuthResult, NbAuthService } from '@nebular/auth';
import { Router } from '@angular/router';
import { LenguageService } from '../../../@core/utils/lenguage.service'

@Component({
  selector: 'ngx-restore-password',
  templateUrl: './restore-password.component.html',
  styleUrls: ['./restore-password.component.scss']
})
export class RestorePasswordComponent extends NbLoginComponent {

  redirectDelay: number = 0;
  showMessages: any = {};
  strategy: string = 'email';

  errors: string[] = [];
  messages: string[] = [];
  user: any = {};
  submitted: boolean = false;
  socialLinks: NbAuthSocialLink[] = [];
  rememberMe = false;

  constructor(
    private auth: AuthService,
    NbAuth: NbAuthService,
    cd: ChangeDetectorRef,
    public language: LenguageService,
    router: Router) {
      super(NbAuth, {}, cd, router);
  }
  ngOnInit() {
  }

  restore(): void {
    this.errors = [];
    this.messages = [];
    this.submitted = true;

    this.auth.sendPasswordResetEmail(this.user.email)
      .then((data) => {
        this.submitted = false;
        this.showMessages = { success: true }
        console.log("DATA",data)
        this.messages = [this.language.getLabel("restore_sent")];
        this.cd.detectChanges();
      })
      .catch((error) => {
        this.submitted = false;
        this.showMessages = { error: true }
        this.errors = [this.language.getLabel("login_error")]
        this.cd.detectChanges();

      });

  }

  getConfigValue(key: string): any {
    return getDeepFromObject(this.options, key, null);
  }

  
  options: any = {
    strategies: [],
    forms: {
      login: {
        redirectDelay: 500, // delay before redirect after a successful login, while success message is shown to the user
        strategy: 'email',  // provider id key. If you have multiple strategies, or what to use your own
        rememberMe: true,   // whether to show or not the `rememberMe` checkbox
        showMessages: {     // show/not show success/error messages
          success: true,
          error: true,
        },
        socialLinks: [], // social links at the bottom of a page
      },
      register: {
        redirectDelay: 500,
        strategy: 'email',
        showMessages: {
          success: true,
          error: true,
        },
        terms: true,
        socialLinks: [],
      },
      validation: {
        email: {
          required: true,
        },
        
      },
    },
  };
}


